import { render, staticRenderFns } from "./QuestionaireList.vue?vue&type=template&id=3bd66836"
import script from "./QuestionaireList.vue?vue&type=script&lang=js"
export * from "./QuestionaireList.vue?vue&type=script&lang=js"
import style0 from "./QuestionaireList.vue?vue&type=style&index=0&id=3bd66836&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports